import { createApp } from 'vue';
import ArwToPngConverter from '../Components/ArwToPngConverter.vue';

const root = document.getElementById('arw-to-png-converter');
if (root) {
  createApp(ArwToPngConverter).mount('#arw-to-png-converter');
}
